<template>
  <div class='MakeCardCheck'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:cardNature="{ item }">
        <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
      </template>
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:validityType="{ item }">
        <span>{{ item.validityType == 2 ? '售卡后生效' : '日期范围' }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

    <service-dialog :show.sync="listDialog.show"
                    @handle="listDialog.confirm"
                    :title="listDialog.title">
      <template v-slot:dialogContent>
        <div class="content">
          <el-checkbox v-for="(shop,index) in listDialog.shopData"
                       :key="index"
                       disabled
                       :checked="true">{{shop}}</el-checkbox>
        </div>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import serviceDialog from '@/components/Dialog'

const sexProps = { label: 'name', value: 'id' }

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      asyncData: { // 接口请求回来的数据
        cardTypeList: []
      },
      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: this.cardTypeList, props: sexProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Date', label: '有效期：', prop: 'validPeriod', placeholder: '请选择有效期' },
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'Date', label: '更新日期：', prop: 'updateDate', placeholder: '请选择更新日期' },
          { type: 'Select', label: '发行方式：', prop: 'issuingType', placeholder: '请选择发行方式', options: this.$label.SendTypes },
          { type: 'Select', label: '卡种类：', prop: 'cardNature', placeholder: '请选择卡种类', options: this.$label.CardTypes }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },

      Table: { // 表格
        selectionHandle: (v) => this.selectionHandle(v),
        primaryBtn: {
          show: true,
          html: '审核',
          handle: (el) => this.checkEvent(el)
        },
        selectedList: [], // 选中的list
        data: [],
        column: [
          { type: 'selection' },
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'cardNature', label: '卡种类', slot: true },
          { prop: 'denomination', label: '面值(元)' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'quantity', label: '数量(张)' },
          { prop: 'validityType', label: '有效期类型', slot: true  },
          { prop: 'validDate', label: '有效期' },
          { prop: 'updateTime', label: '更新日期' },
          // { prop: 'shopIds', label: '适用店铺', type: 'itemEvent' }
        ]
      },

      listDialog: { // 适用店铺
        show: false,
        title: '店铺',
        confirm: () => {
          this.listDialog.show = false
        },
        shopData: [] // 店铺数据
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },

    getItemList () { // 获取列表
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        state: 0,
        ...search.searchData
      }
      this.$http.getCardBatchPagination(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              validDate: item.validityType ? item.validityType == 2 ? `售卡后${item.effectiveDays	}天生效，有效天数${item.validDays	}` : `${item.validBegin} ~ ${item.validEnd}` : '',
              stateText: item.state.text,
              shopIds: !item.shopIds ? '未设置' : `已设置${item.shopIds.split(',').length}`,
              event: {
                use: item.shopIds ? item.shopIds.split(',').length > 0 : false,
                handle: (row) => this.previewShops(row)
              },
              denomination: item.cardNature==0 ? item.denomination : '-'
            }))
          }
        })
    },
    // 点击审核
    checkEvent (el) {
      if (this.Table.selectedList.length === 0) return
      let ids = Array.from(new Set(this.Table.selectedList.map((item) => item.id)))
      ids = ids.join(',')
      const params = {
        id: ids
      }
      this.approvalCardBatch(params, el)
    },

    previewShops (row) {
      this.listDialog.shopData = row.shopNames.split(',')
      this.listDialog.show = true
    },

    selectionHandle (v) {
      this.Table.selectedList = v
    },

    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.asyncData.cardTypeList = res.data
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('卡类型')) {
                item.options = res.data
              }
            })
          }
        })
    },
    // 审核接口
    approvalCardBatch (param, el) {
      this.$http.approvalCardBatch(param)
        .then((res) => {
          if (res.status === 200) {
            el.clearSelection()
            this.getItemList()
          }
        })
    },
    // 初始化
    init () {
      this.getItemList()
      this.getCardTypeList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  .el-checkbox {
    width: 25%;
    margin-right: 0;
    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}
</style>
